import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { PaletteColor, Theme } from "@mui/material";
import { VirtualEventStatus } from "generated-graphql/graphql";

export const virtualEventStatusToIcon = (status: VirtualEventStatus) => {
  switch (status) {
    case VirtualEventStatus.Active:
      return <CircleOutlinedIcon sx={{ fontSize: 14 }} color="info" />;
    case VirtualEventStatus.Overdue:
      return <ErrorOutlineIcon sx={{ fontSize: 14 }} color="error" />;
    case VirtualEventStatus.Completed:
      return <CheckCircleOutlineIcon sx={{ fontSize: 14 }} color="success" />;
  }
};

export const virtualEventStatusToChipSx = (
  status: VirtualEventStatus,
  theme: Theme
) => {
  const statusToColorMap: Record<VirtualEventStatus, PaletteColor> = {
    [VirtualEventStatus.Active]: theme.palette.primary,
    [VirtualEventStatus.Completed]: theme.palette.success,
    [VirtualEventStatus.Overdue]: theme.palette.error,
  };

  const color = statusToColorMap[status];
  return {
    fontSize: 12,
    backgroundColor: `${color.light}20`,
    color: color.main,
  };
};
